export default {
  getMessageConfirmation () {
    return {
      cancel: 'Cancelar',
      label: 'Remover',
      title: 'Confirmar Remoção',
      message: `Deseja remover o profissional <b>${this.currentEntity.name}</b>?`
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/company/staffs/index/resources/computed.js